<x-shop-dialog
  *ngIf="data"
  [heading]="data.heading ?? 'Login required'"
  [subheading]="data.message"
  (closeDialog)="closeDialog()"
  [canClose]="data.canClose"
  [logo]="data.logo"
>
  <x-shop-dialog-actions>
    <button xAction mat-flat-button color="primary" *ngIf="data.login" (click)="action('login')">
      <ng-container i18n="@@CallToAction.Login">Login</ng-container>
    </button>
    <button xAction mat-flat-button color="primary" *ngIf="data.logout" (click)="action('logout')">
      <ng-container i18n="@@CallToAction.Logout">Logout</ng-container>
    </button>
    <button
      xAction
      mat-stroked-button
      color="primary"
      *ngIf="data.register"
      (click)="action('register')"
      i18n="@@CallToAction.Register"
    >
      Register
    </button>
  </x-shop-dialog-actions>
</x-shop-dialog>
